"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultSizeObjectForIllustration = getDefaultSizeObjectForIllustration;
var _illustrations = require("../tokens/illustrations");
var _convertDimensionToSize = require("./convertDimensionToSize");
/** Returns the default size object for an illustration variant */
function getDefaultSizeObjectForIllustration(variant) {
  return (0, _convertDimensionToSize.convertDimensionToSize)(_illustrations.illustrationDimensionDefaults[variant !== null && variant !== void 0 ? variant : 'all']);
}